import { Fragment } from "react";

interface learnLivesProps {
    lives: number;
}

interface learnLifeProps {
    filled: boolean;
}

const LearnLife: React.FC<learnLifeProps> = ({ filled = false }) => {
    return (
        <img
            alt="heart"
            src={
                filled
                    ? "/assets/images/filled-heart.png"
                    : "/assets/images/empty-heart.png"
            }
            className="object-contain w-full h-full"
        />
    );
};

const LearnLives: React.FC<learnLivesProps> = ({ lives }) => {
    return (
        <Fragment>
            <div className="w-8 h-8 mr-1 ">
                <LearnLife filled={lives >= 3} />
            </div>
            <div className="w-8 h-8 mr-1 ">
                <LearnLife filled={lives >= 2} />
            </div>
            <div className="w-8 h-8 ">
                <LearnLife filled={lives >= 1} />
            </div>
        </Fragment>
    );
};

export const LearnHeader = ({ attempts }) => {
    return (
        <div className="fixed top-0 z-10 flex flex-row items-center justify-between h-16 px-4 py-3 bg-white w-i">
            <div className="flex flex-row items-center justify-start">
                <div className="w-10 h-10 mr-4 rounded-full ">
                    <img
                        alt="bulb"
                        src="/assets/images/bulb.png"
                        className="object-contain w-full h-full"
                    />
                </div>
                <span className="text-base font-bold text-dark-purple">
                    {"Learn & solve"}
                </span>
            </div>
            <div className="flex flex-row items-center justify-end">
                <LearnLives lives={attempts} />
            </div>
        </div>
    );
};
